console.log("Print js is run");
customElements.define(
  "cart-pdf",
  class extends HTMLElement {
    constructor() {
      super();
      console.log("Constructor js is run");
      this.jsonElement = this.querySelector("#cart-data-json");
      console.log("JSON:", this.jsonElement);
      this.cartData = JSON.parse(this.jsonElement?.textContent);
      console.log(this.cartData);

      this.pdfNotDiscount = this.querySelector("#pdfNotDiscount");
      this.pdfDiscount = this.querySelector("#pdfDiscount");
      this.pdfBtnNotLoggedin = this.querySelector("#pdfNotLoggedin");

      this.formSubmitBtn = document.querySelectorAll(".pdf-draw");

      this.pdfGenerate = this.pdfGenerate.bind(this);
      //-----------------modal
      this.overlay = document.querySelector("#pdf-overlay");
      this.modalNotDiscount = document.querySelector("#pdfNotDiscountModal");
      this.closeBTNnotDiscount = document.querySelector(
        ".pdf-modal-notDiscount-close"
      );

      this.modalDiscount = document.querySelector("#pdfDiscountModal");
      this.closeBTNDiscount = document.querySelector(
        ".pdf-modal-discount-close"
      );

      this.modalNotLoggedInDiscount = document.querySelector(
        "#pdfNotLoggedinModal"
      );
      this.closeBTNNotLoggedInDiscount = document.querySelector(
        ".pdf-modal-notLoggedIn-close"
      );
      //-----------------modal

      this.formSubmitBtn.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          const type = e.target.closest(".pdf-modal-wrapper").dataset.pdfType;
          this.pdfGenerate(type);
        });
      });

      this.pdfNotDiscount?.addEventListener("click", () => {
        console.log("Print PDF not discount");
        //-----------------modal
        this.modalNotDiscount.classList.remove("hiddenn");
        this.overlay.classList.remove("hiddenn");
        //-----------------modal
      });

      this.closeBTNnotDiscount?.addEventListener("click", () => {
        this.modalNotDiscount.classList.add("hiddenn");
        this.overlay.classList.add("hiddenn");
        this.modalNotDiscount
          .querySelectorAll("input")
          .forEach((input) => (input.value = ""));
      });

      this.closeBTNDiscount?.addEventListener("click", () => {
        this.modalDiscount.classList.add("hiddenn");
        this.overlay.classList.add("hiddenn");
        this.modalDiscount
          .querySelectorAll("input")
          .forEach((input) => (input.value = ""));
      });

      this.closeBTNNotLoggedInDiscount?.addEventListener("click", () => {
        this.modalNotLoggedInDiscount.classList.add("hiddenn");
        this.overlay.classList.add("hiddenn");
        this.modalNotLoggedInDiscount
          .querySelectorAll("input")
          .forEach((input) => (input.value = ""));
      });

      document.addEventListener("keydown", (e, modalDiscount) => {
        if (
          e.key === "Escape" &&
          !this.modalDiscount.classList.contains("hidden")
        ) {
          this.modalDiscount.classList.add("hiddenn");
          this.modalNotDiscount.classList.add("hiddenn");
          this.overlay.classList.add("hiddenn");
        }
      });

      this.pdfDiscount?.addEventListener("click", () => {
        console.log("Print PDF discount");
        //-----------------modal
        this.modalDiscount.classList.remove("hiddenn");
        this.overlay.classList.remove("hiddenn");
        //-----------------modal
      });

      this.pdfBtnNotLoggedin?.addEventListener("click", () => {
        console.log("Print PDF not loggedin");
        //-----------------modal
        this.modalNotLoggedInDiscount.classList.remove("hiddenn");
        this.overlay.classList.remove("hiddenn");
        //-----------------modal
      });
    }

    pdfGenerate = (type) => {
      const client_name = document.querySelector(".modal-client-name")?.value;
      const client_address = document.querySelector(
        ".modal-client-address"
      )?.value;
      const client_zipcode = document.querySelector(
        ".modal-client-zipcode"
      )?.value;
      const client_city = document.querySelector(".modal-client-city")?.value;

      const company_name = document.querySelector(".modal-company-name")?.value;
      const company_id = document.querySelector(".modal-company-id")?.value;
      const company_address = document.querySelector(
        ".modal-company-address"
      )?.value;
      const company_zipcode = document.querySelector(
        ".modal-company-zipcode"
      )?.value;
      const company_city = document.querySelector(".modal-company-city")?.value;

      const pdfDocument = document.querySelector(".printInvoice__wrapper");
      const pdfDocumentHeight = Math.abs(
        pdfDocument.getBoundingClientRect().height + 50
      );
      const pdfDocumentWrapper = document.createElement("div");
      pdfDocumentWrapper.innerHTML = pdfDocument.innerHTML;
      // today date
      const today = new Date();
      pdfDocumentWrapper.querySelector(".printInvoice__dateValue").innerHTML =
        today.toLocaleDateString().replaceAll(".", "/");

      if (type === "client") {
        pdfDocumentWrapper.querySelector(
          ".printInvoice__customerName"
        ).innerHTML = client_name;
        pdfDocumentWrapper.querySelector(
          ".printInvoice__customerAddress"
        ).innerHTML = client_address;
        pdfDocumentWrapper.querySelector(
          ".printInvoice__customerZipcode"
        ).innerHTML = client_zipcode;
        pdfDocumentWrapper.querySelector(
          ".printInvoice__customerCity"
        ).innerHTML = client_city;
        pdfDocumentWrapper.querySelector(
          ".printInvoice__customer"
        ).style.display = "block";
      } else if (type === "company") {
        pdfDocumentWrapper.querySelector(
          ".printInvoice__companyName"
        ).innerHTML = company_name;
        pdfDocumentWrapper.querySelector(
          ".printInvoice__companyAddress"
        ).innerHTML = company_address;
        pdfDocumentWrapper.querySelector(
          ".printInvoice__companyZipcode"
        ).innerHTML = company_zipcode;
        pdfDocumentWrapper.querySelector(".printInvoice__companyId").innerHTML =
          company_id;
        pdfDocumentWrapper.querySelector(
          ".printInvoice__companyCity"
        ).innerHTML = company_city;
        pdfDocumentWrapper.querySelector(
          ".printInvoice__company"
        ).style.display = "block";
      }

      fetch(`${window.apiEndpoint}/api/incrementInvoiceNumber`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          const invoiceNumberElement = pdfDocumentWrapper.querySelector(
            ".printInvoice__numberValue"
          );
          invoiceNumberElement.innerHTML = data.invoiceNumber;

          var worker = html2pdf()
            .set({
              margin: 0,
              filename: "document.pdf",
              image: { type: "jpeg", quality: 1 },
              html2canvas: {
                useCORS: true,
                removeContainer: false,
                scale: 2,
                allowTaint: true,
                windowHeight: pdfDocumentHeight,
                scrollY: 0,
              },
            })
            .from(pdfDocumentWrapper)
            .save();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };
  }
);
